export default "__VITE_ASSET__BwSX1QeM__$_?component__"